<!-- <hr class="my-5" /> -->
<app-payment-form></app-payment-form>
<div class="row">
  <div class="col-md-12">
    <h5 class="card-title">Mis Citas</h5>
    <hr class="linea" />
  </div>
</div>

<div class="row">
  <div class="col-md-8">
    @for (cita of listadoCitas; track $index) {

    <!-- VERSION NO MOBILE -->
    <div class="card" *ngIf="!isMobile" id="">
      <div class="card-body">
        <div>
          <i class="bx bx-calendar-event widget-box-1-icon text-primary"></i>
        </div>
        <div class="row">
          <div class="col-sm order-2 order-sm-1">
            <div class="d-flex align-items-start mt-3 mt-sm-0">
              <div class="flex-shrink-0">
                <div class="avatar-xl me-3 foto-especialista">
                  <img
                    src="{{ cita.idEspecialista.foto }}"
                    alt="{{ cita.idEspecialista.nombre }}"
                    class="img-fluid d-block"
                  />
                </div>
              </div>
              <div class="flex-grow-1">
                <div>
                  @if (cita.idSede != null) {
                  <i class="fas fa-map-marker-alt"></i>
                  {{ cita.idSede.sede }}

                  @if (cita.idSede.sede != 'Online') {
                  <small>Consultorio: </small>{{ cita.consultorio }}
                  } }

                  <h5 class="font-size-16 mb-1">
                    {{ cita.idEspecialista.nombre }}
                  </h5>
                  <p class="text-muted font-size-13">
                    {{ cita.idEspecialista.perfil.especialidad }}
                  </p>

                  <div class="">
                    <i
                      class="mdi mdi-circle-medium me-1 text-success align-middle"
                    ></i
                    >{{ cita.idEstadoCita.estado }}

                    <i
                      class="mdi mdi-circle-medium me-1 text-success align-middle"
                    ></i>
                    {{
                      cita.IdEstadoPago.$id === "creada"
                        ? "Pendiente de pago"
                        : cita.IdEstadoPago.$id === "paquete"
                        ? "Paquete"
                        : "Pago confirmado"
                    }}
                    {{ cita.idSede.sede }}
                    @if (cita.idSede.sede == 'Online' && (cita.idEstadoCita.$id
                    == 'agendada' || cita.idEstadoCita.$id == 'confirmada')) {
                    <br />
                    <i
                      class="mdi mdi-circle-medium me-1 text-success align-middle"
                    ></i>
                    Nota: Para que se active tu link de acceso a la sesión tu
                    consulta debe estar paga }
                  </div>
                  <hr />
                  <!-- Link para iniciar la cita -->

                  <div
                    class="btn-group"
                    role="group"
                    aria-label="Basic mixed styles example"
                  >
                    @if(cita.idEstadoCita.$id == 'agendada'){

                    <a
                      href="javascript: void(0);"
                      (click)="confirmarCita(cita)"
                      class="btn btn-success"
                      >Confirmar
                    </a>
                    } @if(cita.IdEstadoPago.$id === 'aprobada' &&
                    cita.idEstadoCita.$id === 'confirmada' ){

                    <a
                      href="{{ cita.idEspecialista.linkCita }}"
                      target="_blank"
                      class="btn btn-primary"
                    >
                      Iniciar consulta
                    </a>
                    } @if(cita.idEstadoCita.$id == 'agendada' ||
                    cita.idEstadoCita.$id == 'confirmada'){

                    <a
                      href="javascript: void(0);"
                      (click)="cancelarCita(cita)"
                      class="btn btn-danger"
                      >Cancelar
                    </a>

                    <a
                      href="javascript: void(0);"
                      (click)="reprogramarCita(cita)"
                      class="btn btn-warning"
                      >Reprogramar
                    </a>

                    } @if(cita.IdEstadoPago.$id === 'creada' &&
                    cita.idEstadoCita.$id !== 'cancelada' &&
                    cita.idEstadoCita.$id !== 'reprogramada'){

                    <a
                      href="javascript: void(0);"
                      (click)="
                        realizarPago(
                          cita.pagoCita.idCita.$id,
                          cita.pagoCita.valor
                        )
                      "
                      class="btn btn-primary"
                    >
                      Pagar $ {{ cita?.pagoCita?.valor | number : "1.0-0" }}
                    </a>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-auto order-1 order-sm-2">
            <div class="text-sm-end">
              <small>Fecha y hora de tu cita</small><br /><br />
              <h5 class="font-size-18 mb-1">
                <i class="far fa-calendar-alt text-primary"></i>
                {{ cita.fechaCita | spanishDate }}
              </h5>
              <p class="text-muted font-size-16 mb-0">
                <small><i class="far fa-clock"></i></small>
                {{ convertToLocal(cita.fechaCita) | date : "h:mm a" }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- end card body -->
    </div>

    <!-- version mobile -->
    <div *ngIf="isMobile">
      <div class="row">
        <div class="col-sm order-2 order-sm-1">
          <div class="d-flex align-items-start mt-3 mt-sm-0">
            <div class="flex-shrink-0">
              <div class="avatar-xl me-3 foto-especialista">
                <img
                  src="{{ cita.idEspecialista.foto }}"
                  alt="{{ cita.idEspecialista.nombre }}"
                  class="img-fluid d-block"
                />
              </div>
            </div>
            <div class="flex-grow-1">
              <div>
                @if (cita.idSede != null) {
                <i class="fas fa-map-marker-alt"></i>
                {{ cita.idSede.sede }}

                @if (cita.idSede.sede != 'Online') {
                <small>Consultorio: </small>{{ cita.consultorio }}
                } }

                <h5 class="font-size-16 mb-1">
                  {{ cita.idEspecialista.nombre }}
                </h5>
                <p class="text-muted font-size-13">
                  {{ cita.idEspecialista.perfil.especialidad }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-auto order-1 order-sm-2 mt-3 mt-sm-0">
          <div class="text-sm-end">
            <small>Fecha y hora de tu cita</small><br />
            <h5 class="font-size-18 mb-1">
              <i class="far fa-calendar-alt text-primary"></i>
              {{ cita.fechaCita | spanishDate }}
            </h5>
            <p class="text-muted font-size-16 mb-0">
              <small><i class="far fa-clock"></i></small>
              {{ convertToLocal(cita.fechaCita) | date : "h:mm a" }}
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="">
          <i class="mdi mdi-circle-medium me-1 text-success align-middle"></i
          >{{ cita.idEstadoCita.estado }}

          <i class="mdi mdi-circle-medium me-1 text-success align-middle"></i>
          {{
            cita.IdEstadoPago.$id === "creada"
              ? "Pendiente de pago"
              : cita.IdEstadoPago.$id === "paquete"
              ? "Paquete"
              : "Pago confirmado"
          }}
          {{ cita.idSede.sede }}
          @if (cita.idSede.sede == 'Online' && (cita.idEstadoCita.$id ==
          'agendada' || cita.idEstadoCita.$id == 'confirmada')) {
          <br />
          <i class="mdi mdi-circle-medium me-1 text-success align-middle"></i>
          Nota: Para que se active tu link de acceso a la sesión tu consulta
          debe estar paga }
        </div>

        <!-- Link para iniciar la cita -->

        <div
          class="btn-group"
          role="group"
          aria-label="Basic mixed styles example"
        >
          @if(cita.idEstadoCita.$id == 'agendada'){

          <a
            href="javascript: void(0);"
            (click)="confirmarCita(cita)"
            class="btn btn-success"
            >Confirmar
          </a>
          } @if(cita.IdEstadoPago.$id === 'aprobada' && cita.idEstadoCita.$id
          === 'confirmada' ){

          <a
            href="{{ cita.idEspecialista.linkCita }}"
            target="_blank"
            class="btn btn-primary"
          >
            Iniciar consulta
          </a>
          } @if(cita.idEstadoCita.$id == 'agendada' || cita.idEstadoCita.$id ==
          'confirmada'){

          <a
            href="javascript: void(0);"
            (click)="cancelarCita(cita)"
            class="btn btn-danger"
            >Cancelar
          </a>

          <a
            href="javascript: void(0);"
            (click)="reprogramarCita(cita)"
            class="btn btn-warning"
            >Reprogramar
          </a>

          } @if(cita.IdEstadoPago.$id === 'creada' && cita.idEstadoCita.$id !==
          'cancelada' && cita.idEstadoCita.$id !== 'reprogramada'){

          <a
            href="javascript: void(0);"
            (click)="
              realizarPago(cita.pagoCita.idCita.$id, cita.pagoCita.valor)
            "
            class="btn btn-primary"
          >
            Pagar $ {{ cita?.pagoCita?.valor | number : "1.0-0" }}
          </a>
          }
        </div>
      </div>
      <p>&nbsp;</p>
      <hr />
      <!-- end card body -->
    </div>
    <!-- end card -->
    }
  </div>
  <div class="col-md-4">
    <div class="row">
      <div class="col-md-12">
        <h4>
          <i class="fas fa-info-circle"></i> Estimado paciente,
          <strong>recuerde</strong>
        </h4>
        <hr />
        <ul>
          <li>
            Cancelación o Reprogramación de cita con menos de 4 horas de
            anterioridad tienen una multa del 50% del valor de la cita.
          </li>
          <li>Citas Online deben estar pagadas 100% antes de la cita.</li>
          <li>
            Citas Presenciales el pago se realiza antes de comenzar la cita.
          </li>
          <li>
            Convenios empresariales especiales y Colsanitas deben gestionar
            vales y autorizaciones por Whatsapp previamente.
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
